import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { PDFViewer } from '@react-pdf/renderer';
import creditNoteData from '../data/CreditNote';
import CreditNoteDocument from '../components/CreditNoteDocument/CreditNoteDocument';
import { Box, CircularProgress, Typography, Button } from '@mui/material';
import { pdf } from '@react-pdf/renderer';
import axios from 'axios';

const path = 'http://192.168.1.248:3103';

const CreditNotePage = () => {
    const { creditNoteId } = useParams();
    const [CreditNote, setCreditNote] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();

    useEffect(() => {
        const fetch = async () => {
            try {
                console.log('[CreditNotePage] Fetching CreditNote data…', creditNoteId);
                const data = await creditNoteData(creditNoteId);
                console.log('[CreditNotePage] Fetched CreditNote:', data);
                setCreditNote(data);
            } catch (err) {
                console.error('[CreditNotePage] Error:', err);
                setError('Failed to load CreditNote.');
            } finally {
                setLoading(false);
            }
        };
        fetch();
    }, [creditNoteId]);

    // 🧠 Function to send CreditNote to backend
    const sendCreditNoteToBackend = async (CreditNote) => {
        try {
            // 1) Generate the PDF blob
            const blob = await pdf(<CreditNoteDocument CreditNote={CreditNote} />).toBlob();

            // 2) Prepare form data
            const fileName = `${CreditNote.creditNoteNumber}_${CreditNote.companyName}.pdf`;
            const formData = new FormData();
            formData.append('pdf', blob, fileName);
            formData.append('companyName', CreditNote.companyName);
            formData.append('creditNoteNumber', CreditNote.invoiceNo);
            formData.append('mobileNo', CreditNote.mobileNo)

            // now this will be defined
            formData.append('toEmail', CreditNote.toEmail);

            // 🔍 Debug: log every key/value
            for (let [key, val] of formData.entries()) {
                console.log(`FormData ${key}:`, val);
            }

            // 3) Send to backend
            const response = await axios.post(`${path}/api/send-creditNote`, formData, { headers: { 'Content-Type': 'multipart/form-data' }, });

            console.log('Upload success:', response.data);
            alert('CreditNote sent to User!');
        } catch (error) {
            console.error('Error sending CreditNote:', error);
            alert('Failed to send CreditNote.');
        }
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box p={4}>
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    return (
        <Box sx={{ position: 'relative', width: '100%', height: '100vh' }}>
            {/* Fixed Send to User Button */}
            <Button variant="contained" color="primary" onClick={() => sendCreditNoteToBackend(CreditNote)} sx={{ position: 'fixed', top: 10, right: 16, zIndex: 10, }} >
                Send to User
            </Button>
            {/* Full Page PDF Viewer */}
            <Box sx={{ width: '100%', height: '100%' }}>
                <PDFViewer width="100%" height="100%">
                    <CreditNoteDocument CreditNote={CreditNote} />
                </PDFViewer>
            </Box>
        </Box>
    );
};

export default CreditNotePage;